export default "__VITE_ASSET__DSYWcsBW__"